import ApiService from "src/app/model/api/generic/apiService";
import Paging from "src/app/model/api/generic/paging";
import AdjuntoInspeccionClass from "src/app/model/api/inspecciones/adjuntoInspeccionClass";
import ComprobarCertificadosResult from "src/app/model/api/inspecciones/comprobarCertificadosResult";
import ImagenInspeccionClass from "src/app/model/api/inspecciones/imagenInspeccionClass";
import InspeccionClass from "src/app/model/api/inspecciones/inspeccionClass";
import InspeccionesRequest from "src/app/model/api/inspecciones/inspeccionesRequest";
import LogicaClass from "src/app/model/api/inspecciones/logicaClass";

export default class InspeccionesService extends ApiService {

    public async getInspecciones(request: InspeccionesRequest): Promise<Paging<InspeccionClass>> {
        return await this.service.HttpPost('/api/inspecciones/getinspecciones', request)
    }

    public async getInspeccionesPorDia(request: InspeccionesRequest): Promise<Paging<InspeccionClass>> {
        return await this.service.HttpPost('/api/inspecciones/getinspeccionespordia', request)
    }

    public async getInspeccionesDebug(request: InspeccionesRequest): Promise<Paging<InspeccionClass>> {
        return await this.service.HttpPost('/api/inspecciones/getinspeccionesdebug', request)
    }

    public async getInspeccionesPorDiaDebug(request: InspeccionesRequest): Promise<Paging<InspeccionClass>> {
        return await this.service.HttpPost('/api/inspecciones/getinspeccionespordiadebug', request)
    }

    public async getInspeccion(inspeccionId: number): Promise<InspeccionClass> {
        return await this.service.HttpGet('/api/inspecciones/getinspeccion', {
            inspeccionId: inspeccionId
        })
    }

    public async getInspeccionDebug(inspeccionId: number): Promise<InspeccionClass> {
        return await this.service.HttpGet('/api/inspecciones/getinspecciondebug', {
            inspeccionId: inspeccionId
        })
    }

    public async uploadInspeccion(inspeccion: InspeccionClass): Promise<void> {
        return await this.service.HttpPost('/api/inspecciones/uploadInspeccion', inspeccion)
    }

    public async guardarInspeccionView(inspeccion: InspeccionClass): Promise<void> {
        return await this.service.HttpPost('/api/inspecciones/guardarInspeccionView', inspeccion)
    }

    public async getImagenes(inspeccionId: number): Promise<ImagenInspeccionClass[]> {
        return await this.service.HttpGet('/api/inspecciones/getimagenes', {
            inspeccionId: inspeccionId
        })
    }

    public async deleteImagen(inspeccionId: number, imagenId: number): Promise<void> {
        await this.service.HttpDelete('/api/inspecciones/deleteimagen', {
            inspeccionId: inspeccionId,
            imagenId: imagenId
        })
    }

    public async deleteImagenView(imagenId: number): Promise<void> {
        await this.service.HttpDelete('/api/inspecciones/deleteimagenview', {
            imagenId: imagenId
        })
    }

    public async postImagen(data: ImagenInspeccionClass, file: File): Promise<number> {
        let formData = new FormData()
        formData.append('Data', JSON.stringify(data))
        formData.append('Fichero', file)
        return await this.service.HttpPostFormData('/api/inspecciones/postimagen', formData)
    }

    public async postImagenView(data: ImagenInspeccionClass, file: File): Promise<void> {
        let formData = new FormData()
        formData.append('Data', JSON.stringify(data))
        formData.append('Fichero', file)
        await this.service.HttpPostFormData('/api/inspecciones/postsubirimagenview', formData)
    }

    public async postImagenQR(data: ImagenInspeccionClass, file: File): Promise<void> {
        let formData = new FormData()
        formData.append('Data', JSON.stringify(data))
        formData.append('Fichero', file)
        await this.service.HttpPostFormData('/api/inspecciones/subirimagenqr', formData)
    }

    public async downloadImagen(inspeccionId: number, imagenId: number): Promise<string> {
        return await this.service.HttpGetDownloadBase64('/api/inspecciones/getimagen', {
            ImagenId: imagenId,
            InspeccionId: inspeccionId
        })
    }

    public async getViewInspeccion(): Promise<InspeccionClass> {
        return await this.service.HttpGet('/api/inspecciones/getviewinspeccion')
    }

    public async getViewImagenes(): Promise<ImagenInspeccionClass[]> {
        return await this.service.HttpGet('/api/inspecciones/getviewimagenes')
    }

    public async downloadImagenView(imagenId: number): Promise<string> {
        return await this.service.HttpGetDownloadBase64('/api/inspecciones/getviewimagen', {
            ImagenId: imagenId
        })
    }

    public async getFicheros(inspeccionId: number): Promise<AdjuntoInspeccionClass[]> {
        return await this.service.HttpGet('/api/inspecciones/getficheros', {
            inspeccionId: inspeccionId
        })
    }

    public async deleteFichero(inspeccionId: number, ficheroId: number): Promise<void> {
        await this.service.HttpDelete('/api/inspecciones/deletefichero', {
            inspeccionId: inspeccionId,
            ficheroId: ficheroId
        })
    }

    public async deleteFicheroView(ficheroId: number): Promise<void> {
        await this.service.HttpDelete('/api/inspecciones/deleteficheroview', {
            ficheroId: ficheroId
        })
    }

    public async postFichero(data: AdjuntoInspeccionClass, file: File): Promise<number> {
        let formData = new FormData()
        formData.append('Data', JSON.stringify(data))
        formData.append('Fichero', file)
        return await this.service.HttpPostFormData('/api/inspecciones/postFichero', formData)
    }

    public async postFicheroView(data: AdjuntoInspeccionClass, file: File): Promise<void> {
        let formData = new FormData()
        formData.append('Data', JSON.stringify(data))
        formData.append('Fichero', file)
        await this.service.HttpPostFormData('/api/inspecciones/postsubirficheroview', formData)
    }

    public async postFirmaDeConformidad(InspeccionId: number, FileName: string, Texto: string, file: File): Promise<void> {
        let formData = new FormData()
        formData.append('Data', JSON.stringify({
            InspeccionId: InspeccionId,
            FileName: FileName,
            Texto: Texto
        }))
        formData.append('Fichero', file)
        await this.service.HttpPostFormData('/api/inspecciones/postFirmaDeConformidad', formData)
    }

    public async postFirmaDeConservador(InspeccionId: number, FileName: string, Texto: string, file: File): Promise<void> {
        let formData = new FormData()
        formData.append('Data', JSON.stringify({
            InspeccionId: InspeccionId,
            FileName: FileName,
            Texto: Texto
        }))
        formData.append('Fichero', file)
        await this.service.HttpPostFormData('/api/inspecciones/postFirmaDeConservador', formData)
    }

    public async postFirmaDeInspector(InspeccionId: number, FileName: string, Texto: string, file: File): Promise<void> {
        let formData = new FormData()
        formData.append('Data', JSON.stringify({
            InspeccionId: InspeccionId,
            FileName: FileName,
            Texto: Texto
        }))
        formData.append('Ficher', file)
        await this.service.HttpPostFormData('/api/inspecciones/postFirmaDeInspector', formData)
    }

    public async downloadFichero(inspeccionId: number, ficheroId: number): Promise<string> {
        return await this.service.HttpGetDownloadBase64('/api/inspecciones/getfichero', {
            FicheroId: ficheroId,
            InspeccionId: inspeccionId
        })
    }

    public async downloadCertificado(inspeccionId: number, certificadoId: number): Promise<string> {
        return await this.service.HttpGetDownloadBase64('/api/inspecciones/getcertificado', {
            InspeccionId: inspeccionId,
            CertificadoId: certificadoId
        })
    }

    public async firmarInspeccion(Id: number): Promise<void> {
        await this.service.HttpPost('/api/inspecciones/firmarInspeccion', {
            Id: Id
        })
    }

    public async changesubidadesdemovilimagenes(inspeccionId: number): Promise<void> {
        await this.service.HttpGet('/api/inspecciones/changesubidadesdemovilimagenes', {
            inspeccionId: inspeccionId
        })
    }

    public async getViewFicheros(): Promise<AdjuntoInspeccionClass[]> {
        return await this.service.HttpGet('/api/inspecciones/getviewficheros')
    }

    public async downloadFicheroView(ficheroId: number): Promise<string> {
        return await this.service.HttpGetDownloadBase64('/api/inspecciones/getviewifichero', {
            FicheroId: ficheroId
        })
    }

    public async finalizarFirma(inspeccionId: number): Promise<void> {
        return await this.service.HttpGet('/api/inspecciones/finalizarFirma', {
            inspeccionid: inspeccionId
        })
    }

    public async rechazarOT(inspeccionId: number, motivoDescarte: string): Promise<void> {
        return await this.service.HttpPost('/api/inspecciones/rechazarOTv2', {
            inspeccionId: inspeccionId,
            motivoDescarte: motivoDescarte
        })
    }

    public async getProgramaciones(inspeccionId: number): Promise<LogicaClass[]> {
        return await this.service.HttpGet('/api/inspecciones/getProgramaciones', {
            InspeccionId: inspeccionId
        })
    }

    public async getProgramacion(InspeccionId: number, ProgramacionId: number): Promise<LogicaClass> {
        return await this.service.HttpGet('/api/inspecciones/getProgramacion', {
            InspeccionId: InspeccionId,
            ProgramacionId: ProgramacionId
        })
    }

    public async getImagenParametro(InspeccionId: number, Codigo: string): Promise<string> {
        return await this.service.HttpGetDownloadBase64('/api/inspecciones/getimagenparametro', {
            InspeccionId: InspeccionId,
            Codigo: Codigo
        })
    }

    public async comprobarCertificados(InspeccionId: number): Promise<ComprobarCertificadosResult> {
        return await this.service.HttpGet('/api/inspecciones/comprobarcertificados', {
            InspeccionId: InspeccionId
        })
    }

}